export function copyTextToClipboardNoEvent(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(() => {});
  } else {
    // Fallback for older browsers.
    const textArea = document.createElement("textarea");
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
    } finally {
      document.body.removeChild(textArea);
    }
  }
}
